(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      


      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        


        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      


      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-blogs-display"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        // Hover effect
        const post = document.querySelectorAll('.rbd__blog');

        post.forEach((item) => {
            const title = item.querySelector('.rbd__blog-title');
            const image = item.querySelector('.rbd__blog-image img');
            const readMore = item.querySelector('.rbd__blog-readMore');
            item.addEventListener('mouseover', function() {
                item.classList.add('hover');
                if (title) title.classList.add('hover');
                if (image) image.classList.add('hover');
                if (readMore) readMore.classList.add('hover');
            });
            item.addEventListener('mouseout', function() {
                item.classList.remove('hover');
                if (title) title.classList.remove('hover');
                if (image) image.classList.remove('hover');
                if (readMore) readMore.classList.remove('hover');
            });
        });
    });
 
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const saleBannerButton = document.querySelector('.sb__panel-center');
    const saleBannerButtonText = saleBannerButton.querySelector('.sb__panel-center span');
    const saleBannerDetails = document.querySelector('.sb__details');
    const header = document.querySelector('.header');
    const cartMobileIcon = document.querySelector('.header__mobile-buttons .header__icon');
    const searchMobileIcon = document.querySelector('.header__mobile-buttons .header__search');
    const panel_2left = document.querySelector('.sb__panel-2left');

    if (!saleBannerButton) return;

    saleBannerButton.addEventListener('click', function () {
      if (saleBannerDetails.classList.contains('open')) {
        saleBannerDetails.classList.remove('open');
        if (saleBannerButtonText) saleBannerButtonText.textContent = 'See Offer';
        if (cartMobileIcon) cartMobileIcon.classList.remove('moveDown');
        if (searchMobileIcon) searchMobileIcon.classList.remove('moveDown');
        console.log('Sale Banner closed 1');
        return;
      }
      if (saleBannerDetails) {
        saleBannerDetails.classList.add('open');
        if (saleBannerButtonText) saleBannerButtonText.textContent = 'Close [X]';
        if (panel_2left) {
          panel_2left.classList.remove('opacity-08');
          panel_2left.classList.remove('opacity-06');
          panel_2left.classList.remove('opacity-04');
          panel_2left.classList.remove('opacity-02');
          panel_2left.classList.add('opacity-10');
        }

        console.log('Sale Banner opened');

        setTimeout(() => {
          const sbdetailsHeight = saleBannerDetails.offsetHeight;
          if (header) {
            header.style.setProperty('--sbdetails-height', `${sbdetailsHeight}px`);
          }

          if (cartMobileIcon) {
            cartMobileIcon.classList.add('moveDown');
          }

          if (searchMobileIcon) {
            searchMobileIcon.classList.add('moveDown');
          }
        }, 150);
      }
    });

    if (saleBannerDetails) {
      saleBannerDetails.addEventListener('click', function (event) {
        saleBannerDetails.classList.remove('open');
        if (saleBannerButtonText) saleBannerButtonText.textContent = 'See Offer';
        if (cartMobileIcon) cartMobileIcon.classList.remove('moveDown');
        if (searchMobileIcon) searchMobileIcon.classList.remove('moveDown');
        console.log('Sale Banner closed 2');
      });
    }

    // get height of this section then add -sb-height style to header
    const sbHeight = document.querySelector('.sb').offsetHeight;
    if (header) {
      header.style.setProperty('--sb-height', `${sbHeight}px`);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
